module.exports = __webpack_public_path__ + "media/images/diy/testimonial_meghan-9694d72973aa6d3ec5c2de9880dad379.jpg";